import React from 'react';
import { Avatar, Box, Container, Typography } from '@material-ui/core';

const HomeTestimonials = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        align="center"
        color="textPrimary"
        variant="h2"
      >
        &quot;Wir machen ViCo digital&quot;
      </Typography>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          mt: 3
        }}
      >
        <Avatar
          src="/static/eye.png"
          sx={{ mr: 2 }}
        />
        <Typography
          color="textSecondary"
          variant="body3"
        >
          Dein eyerena Team
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default HomeTestimonials;
